import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import { IconVariant, Usp } from '../Usp/Usp';
import styles from './PdpUsps.module.css';

const messages = defineMessages({
  pdpFirst: {
    id: 'src.components.PdpUsps.pdpFirst',
    defaultMessage: 'Home shopping guarantee',
  },
  pdpSecond: {
    id: 'src.components.PdpUsps.pdpSecond',
    defaultMessage: 'Ordered before 17:00, delivered tomorrow',
  },
  pdpThird: {
    id: 'src.components.PdpUsps.pdpThird',
    defaultMessage: 'Companies order on invoice',
  },
  pdpFours: {
    id: 'src.components.PdpUsps.pdpFours',
    defaultMessage: 'Customer service available by phone and email',
  },
  modalFirst: {
    id: 'src.components.PdpUsps.modalFirst',
    defaultMessage: 'Quote within one hour',
  },
  modalSecond: {
    id: 'src.components.PdpUsps.modalSecond',
    defaultMessage: 'Companies order on invoice',
  },
  modalThird: {
    id: 'src.components.PdpUsps.modalThird',
    defaultMessage: 'Direct contact with your personal account manager',
  },
  modalFours: {
    id: 'src.components.PdpUsps.modalFours',
    defaultMessage: 'Personalized Gift Cards & Packaging',
  },
});

const toBasketUsps = [
  'pdpFirst',
  'pdpSecond',
  'pdpThird',
  'pdpFours',
] as (keyof typeof messages)[];
const businessModalUsps = [
  'modalFirst',
  'modalSecond',
  'modalThird',
  'modalFours',
] as (keyof typeof messages)[];

export type Props = {
  isToBasketUsps?: boolean;
};

export const PdpUsps = React.memo((props: Props) => {
  const { isToBasketUsps } = props;
  return (
    <ul
      className={classNames(styles.pdpUsps, {
        [styles.pdpUspsModal]: !isToBasketUsps,
      })}
    >
      {isToBasketUsps
        ? toBasketUsps.map((usp, idx) => (
          <li key={`pdp-usp_${idx}`}>
            <Usp
              className={styles.pdpUspsItem}
              iconClassName={styles.icon}
              variant='bodySubText1'
              iconVariant={IconVariant.Guard}
            >
              <FormattedMessage {...messages[usp]} />
            </Usp>
          </li>
        ))
        : businessModalUsps.map((usp, idx) => (
          <li key={`pdp-usp_${idx}`}>
            <Usp
              className={styles.pdpUspsItem}
              iconClassName={styles.icon}
              variant='bodySubText1'
              iconVariant={IconVariant.Guard}
            >
              <FormattedMessage {...messages[usp]} />
            </Usp>
          </li>
        ))
      }
    </ul>
  );
});

PdpUsps.displayName = 'PdpUsps';
